import React from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "../ui/button";
import sparkleIcon from "@/assets/sparkle.svg";

interface CollapsedChatPanelProps {
  onToggleCollapse: () => void;
}

/**
 * Compact rail shown when the chat panel is collapsed. Provides a single
 * affordance to expand the panel back open.
 */
export function CollapsedChatPanel({
  onToggleCollapse,
}: CollapsedChatPanelProps) {
  return (
    <div className="flex flex-col h-full items-center py-4 gap-4">
      <Button
        variant="ghost"
        size="icon"
        onClick={onToggleCollapse}
        className="h-8 w-8 text-muted-foreground hover:text-foreground"
        title="Expand chat panel"
      >
        <ChevronRight className="h-5 w-5" />
      </Button>
      <img src={sparkleIcon} alt="AI Assistant" className="w-6 h-6" />
      <div className="flex-1" />
    </div>
  );
}

export default CollapsedChatPanel;
